import Swiper, {Autoplay, Navigation, Pagination} from "swiper";
import {collapse} from "../collapse";
import {sliders} from "../sliders";
import {productSlider} from "../productSlider";
import {userGeolocation} from "../userGeolocation";
import {filterSearch} from "../filterSearch";
import addFavorite from "../addFavorite";
import {alert} from "../alert";
import zipperModal from "../zipperModal";
import {LiteFilter} from "../liteFilter";
import {PriceRequest} from "../price-request";
import {menu} from "../menu";
import {ShowMore} from "../show-more";
import {PlayVideo} from "../play-video";
import {CatalogFilter} from "../catalog-filter";
import {stickyHeader} from "../sticky-header";
import {AdditionalCatalogFilter} from "../additional-catalog-filter";

Swiper.use([Navigation, Pagination, Autoplay]);

menu();

collapse({});

sliders(Swiper);

productSlider();

userGeolocation();

filterSearch();

addFavorite({activeClass: `add-favorite--pressed`});

alert();

zipperModal();

const openPriceRequestElement = document.querySelector(`.js-price-request-open`);
if (openPriceRequestElement) {
  new PriceRequest().init();
}

const favoritesFilter = new LiteFilter({
  containerSelector: `.js-favorite-filter`,
  buttonSelector: `.js-favorite-filter-btn`,
  itemToFilterSelector: `.js-favorite-filter-item`,
});
favoritesFilter.init();

new ShowMore();

new PlayVideo({});

new CatalogFilter();
new AdditionalCatalogFilter();

stickyHeader();
